import { render, staticRenderFns } from "./parentEnd.vue?vue&type=template&id=27ff20f1&scoped=true"
import script from "./parentEnd.vue?vue&type=script&lang=js"
export * from "./parentEnd.vue?vue&type=script&lang=js"
import style0 from "./parentEnd.vue?vue&type=style&index=0&id=27ff20f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff20f1",
  null
  
)

export default component.exports